<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mUQekg/tc-custom/9781400323791.jpg?1726519331073" alt="This image is the cover for the book Daily Light"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Daily Light
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Let God’s Word light your way.</b></p><p>One of the most beloved devotionals of all time! For over two hundred years, Samuel Bagster’s classic and timeless <i>Daily Light on the Daily Path </i>has encouraged and strengthened readers with the words of Scripture. The devotional gathers what the Bible has to say on issues such as worry, hope, wisdom, and peace and arranges them so that the Bible speaks directly to felt needs. This beautifully packaged landmark devotional is Scripture only—simple, straightforward, and always relevant. </p><p>A quick read perfect for busy people who love the Word, this compilation of related verses based on a daily theme will light readers' paths each morning and evening!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Nelson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c90418b2